import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { Card } from 'components/Card';
import Message from 'components/Message';
import Button from 'components/Button';
import { manageServicesAvailabilityShape, servicesPropTypes } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import EmptyDetails from '../../EmptyDetails';
import MissingObjectsCard from '../../Components/MissingObjectsCard/MissingObjectsCard';
import { AvailabilityDetails } from '../../Components/AvailabilityDetails';
import ServicesSummary from '../../Components/ServicesSummary/ServicesSummaryContainer';
import { messages } from '../Resources.messages';
import './ResourceDetails.scss';

const { block, element } = bem('resource-details');

const ResourceDetails = ({ resource, handleEditClick }) => {
  const isEmpty = _isEmpty(resource);
  const { name, recurrence, singleDayExceptions, services } = resource;

  return (
    <Card className={block()} centered={isEmpty}>
      {isEmpty && <EmptyDetails text={messages.details.placeholder} />}
      {!isEmpty && (
        <>
          <div className={element('header')}>
            <div className={element('header-title')} data-cypress="resources-details-header">
              {name}
            </div>
            <Message
              as={Button}
              className={element('edit-button')}
              styled={false}
              onClick={handleEditClick}
              message={messages.details.editResource}
              data-cypress="resource-edit-button"
            />
          </div>
          {_isEmpty(services) && (
            <MissingObjectsCard
              titleMessage={messages.details.missingObjectsTitle}
              copyMessage={messages.details.missingObjectsCopy}
            />
          )}
          <hr />
          <div className="grid grid--flush">
            {(!_isEmpty(recurrence) || !_isEmpty(singleDayExceptions)) && (
              <div className="grid__item md-1/2">
                <AvailabilityDetails recurrence={recurrence} singleDayExceptions={singleDayExceptions} />
              </div>
            )}

            <div className="grid__item md-1/2">
              <ServicesSummary services={services} />
            </div>
          </div>
        </>
      )}
    </Card>
  );
};

ResourceDetails.propTypes = {
  resource: PropTypes.shape({
    name: PropTypes.string,
    capacity: PropTypes.number,
    recurrence: manageServicesAvailabilityShape.recurrence,
    singleDayExceptions: manageServicesAvailabilityShape.singleDayExceptions,
    services: servicesPropTypes,
  }),
  handleEditClick: PropTypes.func,
};

export default ResourceDetails;
